import { render, staticRenderFns } from "./CourierMenuEdit.vue?vue&type=template&id=aa23a2fc&"
import script from "./CourierMenuEdit.vue?vue&type=script&lang=js&"
export * from "./CourierMenuEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports